import Instance from '../../../utils/Axios';

// New Actions for the app

const GetTipoPeriodo = (id) => async (dispatch) => {
  await Instance()
    .get(`/tipoperiodos/${id}`)
    .then(({ data }) => {
      dispatch({ type: 'GET_TIPOPERIODO', payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetTipoPeriodo;
